<template>
  <svg
    width="42"
    height="34"
    viewBox="0 0 42 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Sort</title>
    <g filter="url(#filter0_d_19570_151576)">
      <rect x="1" y="1" width="40" height="32" rx="16" fill="transparent" shape-rendering="crispEdges" />

      <g mask="url(#mask0_19570_151576)">
        <path
          d="M12.5 11.5V13H17.875V11.5H12.5ZM12.5 16.25V17.75H23.6827V16.25H12.5ZM12.5 21V22.5H29.5V21H12.5Z"
          fill="#1E264C"
        />
        <path
          d="M27.0005 7.28854L22.2891 12L23.1672 12.8781L26.3755 9.66979V17.625H27.6255V9.66979L30.8339 12.8781L31.712 12L27.0005 7.28854Z"
          fill="#1E264C"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_19570_151576"
        x="0"
        y="0"
        width="42"
        height="34"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19570_151576" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19570_151576" result="shape" />
      </filter>
    </defs>
  </svg>

</template>

<style scoped>

</style>
